import React from 'react'
import { Button } from 'react-bootstrap'
import { ChatText } from 'react-bootstrap-icons'

import { useApplicationState } from '@hooks/common/use-application-state';

function CommentButton() {
  const { commentCount } = useApplicationState((state) => ({
    commentCount: state.commentsData.count,
  }));
  return (
    <Button
      disabled={true}
      className='d-flex gap-2 align-items-center'
      variant='outline-dark'
    >
      <ChatText /> {commentCount} comments
    </Button>
  )
}

export default CommentButton
